import DropdownList from 'react-widgets/lib/DropdownList';
import SelectList from 'react-widgets/lib/SelectList';
import React from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import PropTypes from 'prop-types';

import { parseInputToDate } from '../../../utils';
import { ErrorBanner } from '../../../common/ErrorBanner/ErrorBanner';


export const renderDropdownList = ({ input, data, placeholder }) =>
  <DropdownList
    {...input}
    data={data}
    placeholder={placeholder}
    valueField="valueField"
    textField="textField"
    // eslint-disable-next-line react/prop-types
    onChange={input.onChange}
  />;

renderDropdownList.propTypes = {
  input: PropTypes.instanceOf(Object),
  data: PropTypes.instanceOf(Object),
  textField: PropTypes.string,
  valueField: PropTypes.string,
  placeholder: PropTypes.string,
};
// eslint-disable-next-line react/prop-types
export const renderSelectList = ({ input, disabled, defaultValue, ...rest }) => (
  <div>
    <SelectList
      className="list-radio"
      {...rest}
      value={input.value || defaultValue}
      onChange={input.onChange}
      disabled={disabled}
    />
  </div>
);
renderSelectList.propTypes = {
  input: PropTypes.instanceOf(Object),
};

export const renderDateTimePicker = ({ input, meta: { error, touched }, defaultCurrentDate,
  disabled, showTime, placeholder, min, max }) => (
    <div>
      <DateTimePicker
        {...input}
        format="DD-MM-YYYY"
        parse={['DD-MM-YYYY', 'DD/MM/YYYY', 'DDMMYYYY', 'DD.MM.YYYY']}
        time={showTime}
        value={!input.value ? null : parseInputToDate(input.value)}
        placeholder={placeholder}
        min={min}
        max={max}
        disabled={disabled}
        defaultCurrentDate={defaultCurrentDate}
        defaultView="decade"
        className={touched && error ? 'error-border' : ''}
      />
      {touched && error &&
      <ErrorBanner
        title={error}
      />}
    </div>);
renderDateTimePicker.propTypes = {
  input: PropTypes.instanceOf(Object),
  meta: PropTypes.instanceOf(Object),
  showTime: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  defaultCurrentDate: PropTypes.instanceOf(Date),
};
